import React from 'react'
import { isEmpty } from 'lodash'
import SectionRender from './SectionRender'
import Skeleton from '../../../ui/Skeleton/Skeleton'

function FormRender({ sections, sectionsSkeleton = [], form, setForm, errors, isFormSaved, closeForm }) {
  return !isEmpty(sections) && !isEmpty(form) ? (
    sections.map((section, i) => (
      <SectionRender
        key={`${section.title}-${i}`}
        {...section}
        form={form}
        setForm={setForm}
        errors={errors}
        isFormSaved={isFormSaved}
        closeForm={closeForm}
      />
    ))
  ) : (
    <FormRenderSkeleton sectionsSkeleton={sectionsSkeleton} />
  )
}

function FormRenderSkeleton({ sectionsSkeleton }) {
  return sectionsSkeleton.map((s, sectionIndex) => {
    const fields = []
    for (let index = 0; index < s; index++) {
      fields.push(<Skeleton key={`field-${sectionIndex}-${index}`} height={28} />)
    }

    return (
      <React.Fragment key={`section-${sectionIndex}`}>
        <div className="SceneContent-Header">
          <Skeleton width={80} />
        </div>
        {fields}
      </React.Fragment>
    )
  })
}

export default FormRender
